import {
	DropdownMenuContent,
	type DropdownMenuContentProps,
	DropdownMenuItem,
	type DropdownMenuItemProps,
	DropdownMenuLabel,
	type DropdownMenuLabelProps,
	DropdownMenuSeparator,
	type DropdownMenuSeparatorProps
} from '@radix-ui/react-dropdown-menu'
import { forwardRef } from 'react'
import { cn } from '@/helpers/utils'

export const DropdownContent = forwardRef<
	HTMLDivElement,
	DropdownMenuContentProps
>(({ className, ...props }, ref) => (
	<DropdownMenuContent
		className={cn(
			'max-h-[400px] w-[200px] overflow-auto rounded-lg border border-neutral-300 bg-neutral-white py-1 shadow-lg',
			className
		)}
		ref={ref}
		{...props}
	/>
))
DropdownContent.displayName = 'DropdownContent'

export const DropdownLabel = ({
	className,
	...props
}: DropdownMenuLabelProps) => (
	<DropdownMenuLabel
		className={cn(
			'px-3 py-1 font-medium text-neutral-500 text-xs',
			className
		)}
		{...props}
	/>
)
DropdownLabel.displayName = 'DropdownLabel'

export const DropdownSeparator = ({
	className,
	...props
}: DropdownMenuSeparatorProps) => (
	<DropdownMenuSeparator
		className={cn('my-1 h-px w-full bg-neutral-300', className)}
		{...props}
	/>
)
DropdownSeparator.displayName = 'DropdownSeparator'

export const DropdownItem = ({
	className,
	...props
}: DropdownMenuItemProps) => (
	<DropdownMenuItem
		className={cn(
			'w-full overflow-hidden truncate p-2.5 font-medium text-neutral-700 text-sm transition-all duration-150 ease-in-out',
			'hover:not-data-disabled:cursor-pointer hover:not-data-disabled:bg-neutral-50',
			'focus:not-data-disabled:cursor-pointer focus:not-data-disabled:bg-neutral-50',
			'data-disabled:pointer-events-none data-disabled:cursor-not-allowed',
			className
		)}
		{...props}
	/>
)
DropdownItem.displayName = 'DropdownItem'
